
import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule, ReactiveFormsModule, UntypedFormControl } from "@angular/forms";
import { CheckboxListComponent } from "@components/checkbox-list/checkbox-list.component";
import { FieldsetToggleComponent } from "@components/fieldset-toggle/fieldset-toggle.component";
import { Observable, of } from "rxjs";
import { ITplArbetsorder } from "../../../models/dtos";
import { FilterBaseComponent } from "../filter-base-component";
import { TplFilterContext } from "../tpl-filter-context";
import { ITplArbetsorderFilter } from "../tpl-filter.models";

@Component({
    selector: "rask-tpl-nasfranvag-filter",
    templateUrl: "./tpl-nasfranvag-filter.component.html",
    styleUrls: ["./tpl-nasfranvag-filter.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        FieldsetToggleComponent,
        FormsModule,
        ReactiveFormsModule,
        CheckboxListComponent
    ]
})
export class TplNasfranvagFilterComponent extends FilterBaseComponent implements OnInit, ITplArbetsorderFilter {
    options: Observable<string[]>;

    expectNasFranVag: boolean;
    expectNotNasFranVag: boolean;

    constructor() {
        super("nasfranvag");
    }

    ngOnInit(): void {
        this.onFormInit(new UntypedFormControl([]));
        this.initOptions();
    }

    onFilterInit(state: any): void {
        state = state ?? [];
        this.control.setValue(state);
    }

    match(item: ITplArbetsorder): boolean {
        if (this.expectNasFranVag === this.expectNotNasFranVag) {
            return true;
        }

        if (this.expectNasFranVag) {
            return item.nasFranVag;
        }

        if (this.expectNotNasFranVag) {
            return !item.nasFranVag;
        }

        return false;
    }

    prepare() {
        const value = this.value();
        this.expectNasFranVag = value.some(x => x === "Ja");
        this.expectNotNasFranVag = value.some(x => x === "Nej");
    }

    value(): string[] {
        return this.control.value;
    }

    isActive(): boolean {
        return this.value()?.length > 0;
    }

    protected onAddFilterToContext(filterContext: TplFilterContext) {
        filterContext.addArbetsorderFilter(this.name, this);
    }

    protected onFormChange(value: string[]): void {
        this.filterLength = !value ? 0 : value.length;
    }

    private initOptions(): void {
        const options = [
            "Ja",
            "Nej"
        ];
        this.options = of(options);
    }

}
